import { render, staticRenderFns } from "./MidtermCompletedStudents.vue?vue&type=template&id=17939d50&scoped=true"
import script from "./MidtermCompletedStudents.vue?vue&type=script&lang=js"
export * from "./MidtermCompletedStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17939d50",
  null
  
)

export default component.exports